import { Component, Input, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CellType, IgxDialogComponent } from '@infragistics/igniteui-angular';
import { Discount, DiscountForm } from 'src/app/models/discount';
import { ConditionType } from 'src/app/models/enums/conditionType';
import { Program } from 'src/app/models/program';
import { MessagesService } from 'src/app/services/messages.service';
import { ProgramsService } from 'src/app/services/programs.service';
import { updateCollection } from 'src/app/shared/utils';

@Component({
    selector: 'app-add-discount',
    templateUrl: './add-discount.component.html',
    styleUrls: ['./add-discount.component.scss']
})
export class AddDiscountComponent {
    private _editDiscount: Discount;

    @ViewChild('dialog', { static: true, read: IgxDialogComponent })
    private _dialog?: IgxDialogComponent;

    @Input() public program?: Program;
    public dialogText: string = 'Добави';
    public discountForm: FormGroup<DiscountForm>;

    constructor(
        private programService: ProgramsService,
        private msgs: MessagesService) {
        this.discountForm = new FormGroup<DiscountForm>({
            value: new FormControl<number | null>(0, [Validators.required, Validators.min(1)]),
            description: new FormControl('', Validators.required),
            conditionType: new FormControl<ConditionType | null>(0),
            date: new FormControl<Date | null>(null),
            summable: new FormControl<boolean | null>(false)
        });
        this._editDiscount = this._emptyDiscount();
    }

    public addDiscount = (dialog: IgxDialogComponent): void => {
        this._editDiscount = this._emptyDiscount();
        this.discountForm.reset(this._editDiscount);
        this.dialogText = 'Добави';
        dialog.open();
    }

    public updateDiscount = (dialog: IgxDialogComponent, cell: CellType): void => {
        this._editDiscount = cell.row.data;
        this.discountForm.reset(this._editDiscount);
        this.dialogText = 'Редактирай';
        dialog.open();
    }

    public discountSubmit = (): void => {
        if (this.dialogText === 'Добави') {
            this._addDiscount();
        }
        if (this.dialogText === 'Редактирай') {
            this._updateDiscount();
        }
    }

    public closeDialog = (dialog: IgxDialogComponent): void => {
        this._editDiscount = this._emptyDiscount();
        this.discountForm.reset(this._emptyDiscount());
        dialog.close();
    }

    public discounts = (): Discount[] => {
        if (this.program) {
            return this.program.discounts;
        }
        return [];
    }

    public parseConditionType = (cell: CellType): string => {
        switch (cell.value) {
            case 0:
                return 'Винаги';
            case 1:
                const date: Date = cell.row.data.date;
                return `Преди ${date.toLocaleDateString('bg-BG')}`;
            case 2:
                return 'Приятел';
            case 3:
                return 'Роднина';
            case 4:
                return 'Стар клиент';
        }
        return '';
    }

    public parcePercent = (value: any): number => {
        return value / 100;
    }

    private _addDiscount = async () => {
        try {
            const discount = await this.programService.addDiscount({ ...this.discountForm.value, program: this.program?.id });
            this.msgs.success(`Отстъпката е успешно добавена.`);
            this.program!.discounts = updateCollection(discount, this.program?.discounts ?? []);
            this.closeDialog(this._dialog!);
        }
        catch (err) {
            this.msgs.error(err);
            this.closeDialog(this._dialog!);
        }
    }

    private _updateDiscount = async () => {
        try {
            const discount = await this.programService.updateDiscount({ ...this.discountForm.value, id: this._editDiscount.id, program: this.program?.id });
            this.program!.discounts = updateCollection(discount, this.program?.discounts ?? []);
            this.msgs.success(`Отстъпката е успешно добавена.`);
            this.closeDialog(this._dialog!);
        }
        catch (err) {
            this.msgs.error(err);
            this.closeDialog(this._dialog!);
        }
    }

    private _emptyDiscount = (): Discount => {
        return {
            value: 0,
            description: '',
            conditionType: ConditionType.None,
            date: undefined,
            summable: false,
            program: this.program!
        }
    };
}
